import { render, staticRenderFns } from "./OrderPaymentDialog.vue?vue&type=template&id=5649e087&scoped=true&"
import script from "./OrderPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649e087",
  null
  
)

export default component.exports